import { vaultPostRequest } from '../helpers';
import type { ICompleteClipUploadRequest } from './complete-clip-upload-request';
import type { ICompleteClipUploadResponse } from './complete-clip-upload-response';
import { completeClipUploadResponseSchema } from './complete-clip-upload-response';

export async function completeClipUploadApi({
  apiUrl,
  clipId,
  path,
}: ICompleteClipUploadRequest): Promise<ICompleteClipUploadResponse> {
  return vaultPostRequest({
    path: `/vault/clips/${clipId}/upload-complete`,
    body: { path },
    schema: completeClipUploadResponseSchema,
    baseUrl: apiUrl,
  });
}
